import './modules/aosConfig';
import './modules/navigation';
